import { Icon } from "@/ds";

import styles from "./conflict-detail-dialog.module.scss";
import type { ConflictDetailDialogProps } from "./types-conflict-detail-dialog";

export function ConflictDetailDialogView({ conflicts, point }: ConflictDetailDialogProps) {
  if (!conflicts || conflicts.length === 0) return null;

  return (
    <div
      className={styles.tooltip}
      style={{ left: point.x, top: point.y }}
      role="tooltip"
      data-testid="conflict-detail-tooltip"
    >
      <span className={styles.title}>
        <Icon name="exclamation-triangle" size={10.5} />
        Conflito Detectado
      </span>
      {conflicts.map((conflict) => (
        <div
          key={`${conflict.primeira}|${conflict.segunda}|${conflict.inicio}`}
          className={styles.group}
        >
          <p className={`${styles.row} ${styles.rowStart}`}>
            <strong>Obra {conflict.primeira}</strong>
            <span>início em {conflict.inicio}</span>
          </p>
          <p className={`${styles.row} ${styles.rowEnd}`}>
            <strong>Obra {conflict.segunda}</strong>
            <span>término em {conflict.fim}</span>
          </p>
        </div>
      ))}
    </div>
  );
}
